require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-sanjala-chitnis.json") })
        }
      }, "path---blog-author-sanjala-chitnis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-sanjala-chitnis!./.cache/json/blog-author-sanjala-chitnis.json
// module id = 697
// module chunks = 231608221292675